const state = {

    Banners : []
    
  }
  
  const mutations = {
    SetBanners(state, payload){
        state.Banners = payload
    },
    SetIndividualBanner(state, payload){
        state.Banners.push(payload)
    },
    UpdateIndividualBanner(state, payload){

        let index = state['Banners'].findIndex(x => x["_id"] == payload["_id"])
        state['Banners'].splice(index,1,payload)
    },
    DeleteIndividualBanner(state, payload){

        let index = state['Banners'].findIndex(x => x["_id"] == payload["_id"])
        state['Banners'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetBanners(state){

        return state.Banners
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  